import type { Conversation } from './types';
export const demoConversations: Conversation[] = [
  {
    id: 'marta',
    name: 'Marta',
    initials: 'MK',
    avatarHue: 174,
    status: 'online',
    lastMessage: 'Jasne, widzimy się o 18:30 ✨',
    time: '14:42',
    unread: 2,
    typing: true,
    messages: [
      { id: '1', author: 'contact', text: 'Hej! Jak Ci mija dzień?', timestamp: '14:31' },
      {
        id: '2',
        author: 'me',
        text: 'Całkiem dobrze. Właśnie kończę pracę nad Linkiem.',
        timestamp: '14:34',
        status: 'read',
      },
      { id: '3', author: 'me', text: 'Może spacer wieczorem?', timestamp: '14:34', status: 'read' },
      {
        id: '4',
        author: 'contact',
        text: 'Bardzo chętnie! Park przy rzece?',
        timestamp: '14:38',
        replyTo: 'Może spacer wieczorem?',
      },
      {
        id: '5',
        author: 'me',
        text: 'Pasuje. Będę przy głównym wejściu o 18:30.',
        timestamp: '14:40',
        status: 'delivered',
      },
      { id: '6', author: 'contact', text: 'Jasne, widzimy się o 18:30 ✨', timestamp: '14:42' },
    ],
  },
  {
    id: 'pawel',
    name: 'Paweł',
    initials: 'PN',
    avatarHue: 218,
    status: 'ostatnio aktywny dzisiaj',
    lastMessage: 'Podeślę Ci zdjęcia jutro.',
    time: '12:08',
    unread: 0,
    messages: [
      { id: 'p1', author: 'contact', text: 'Podeślę Ci zdjęcia jutro.', timestamp: '12:08' },
    ],
  },
  {
    id: 'ola',
    name: 'Ola',
    initials: 'OZ',
    avatarHue: 28,
    status: 'status prywatny',
    lastMessage: 'Nie udało się wysłać',
    time: 'wczoraj',
    unread: 0,
    messages: [
      {
        id: 'o1',
        author: 'me',
        text: 'To bardzo długa wiadomość demonstracyjna, która pokazuje poprawne zawijanie tekstu i bardzo-długi-link.example.com/sciezka/ktora-nie-powinna-rozszerzyc-dymka-poza-ekran',
        timestamp: '20:14',
        status: 'error',
      },
    ],
  },
  {
    id: 'tata',
    name: 'Tata',
    initials: 'TS',
    avatarHue: 94,
    status: 'ostatnio aktywny wczoraj',
    lastMessage: 'Dziękuję!',
    time: 'pt.',
    unread: 4,
    messages: [{ id: 't1', author: 'contact', text: 'Dziękuję!', timestamp: '09:12' }],
  },
];
